const TARGET_KEYWORD = '3-Month';

$(document).ready(function () {
  const MAX_RETRIES = 10;
  const INITIAL_DELAY = 200;
  const BACKOFF_FACTOR = 1.5;

  const applyPriceUpdate = () => {
    $('.tolstoy-product-tile-title').each(function () {
      const titleText = $(this).text().trim();

      if (new RegExp(`\\(${TARGET_KEYWORD}\\)`).test(titleText)) {
        const container = $(this).closest('tolstoy-carousel > div > div.tolstoy-carousel-videos-container > div > div > div.tolstoy-product-content > div:nth-child(1) > div > div');
        const subtitleElement = container.find('.tolstoy-product-tile-subtitle');

        if (subtitleElement.length && !subtitleElement.data('modified')) {
          const priceText = subtitleElement.text().trim();
          const priceNumber = parseFloat(priceText.replace('$', ''));
          if (!isNaN(priceNumber)) {
            const multipliedPrice = priceNumber * 2;
            subtitleElement.html(`$${multipliedPrice}`);
            subtitleElement.data('modified', true);
          }
        }
      }
    });
  };

  const checkElementsAndApply = (attempt = 0, delay = INITIAL_DELAY) => {
    console.log(`Checking for elements (attempt ${attempt + 1})...`);

    const carouselContainer = $('.tolstoy-carousel-videos-container');

    if (carouselContainer.length) {
      console.log('Carousel container found! Applying price updates...');

      setInterval(() => {
        applyPriceUpdate();
      }, 1000);

      console.log('Setting up MutationObserver for carousel...');
      const observer = new MutationObserver(() => {
        console.log('Mutation detected — running price update again.');
        applyPriceUpdate();
      });

      observer.observe(carouselContainer[0], {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });

      return;
    }

    if (attempt < MAX_RETRIES - 1) {
      const nextDelay = Math.min(delay * BACKOFF_FACTOR, 5000);
      setTimeout(() => {
        checkElementsAndApply(attempt + 1, nextDelay);
      }, delay);
    }
  };

  checkElementsAndApply();
});


window.addEventListener("tolstoyWidgetReady", function () {

  const expandedDivs = document.querySelectorAll('div[data-is-expanded="true"]');
  console.log(`Found ${expandedDivs.length} expanded divs`);

  expandedDivs.forEach((expandedDiv, divIndex) => {
    console.log(`\n=== Processing Expanded Div ${divIndex + 1} ===`);

    const allProductTiles = expandedDiv.querySelectorAll(':scope > .tolstoy-product-tile');
    const productTilesFromSecond = Array.from(allProductTiles).slice(1);

    console.log(`Found ${productTilesFromSecond.length} product tiles (excluding first child) in div ${divIndex + 1}`);

    productTilesFromSecond.forEach((tile, index) => {
      const titleElement = tile.querySelector('.tolstoy-product-tile-title');
      const subtitleElement = tile.querySelector('.tolstoy-product-tile-subtitle');

      if (titleElement && subtitleElement) {
        const titleText = titleElement.textContent.trim();
        const subtitleText = subtitleElement.textContent.trim();

        console.log(`\n  Tile ${index + 2} (Div ${divIndex + 1}):`);
        console.log(`  Title: "${titleText}"`);
        console.log(`  Subtitle: "${subtitleText}"`);

        if (titleText.includes(`(${TARGET_KEYWORD})`)) {
          console.log(`  ✓ Title contains "(${TARGET_KEYWORD})"`);

          const compareSpans = subtitleElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');

          let numberToMultiply = null;
          let isComparePrice = false;

          if (compareSpans.length > 0) {
            isComparePrice = true;
            const tempElement = subtitleElement.cloneNode(true);
            const tempCompareSpans = tempElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
            tempCompareSpans.forEach(span => span.remove());
            const mainPriceText = tempElement.textContent.trim();
            const mainPriceMatch = mainPriceText.match(/\d+(\.\d+)?/);
            if (mainPriceMatch) {
              numberToMultiply = parseFloat(mainPriceMatch[0]);
            }
          } else {
            const numberMatch = subtitleText.match(/\d+(\.\d+)?/);
            if (numberMatch) {
              numberToMultiply = parseFloat(numberMatch[0]);
              console.log(`  💰 Single price found: $${numberToMultiply}`);
            }
          }

          if (numberToMultiply) {
            const multipliedNumber = numberToMultiply * 2;
            console.log(`  🔢 $${numberToMultiply} × 2 = $${multipliedNumber}`);

            if (isComparePrice) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = subtitleElement.innerHTML;

              const walker = document.createTreeWalker(
                tempDiv,
                NodeFilter.SHOW_TEXT,
                {
                  acceptNode: function (node) {
                    let parent = node.parentNode;
                    while (parent && parent !== tempDiv) {
                      if (parent.classList && (
                        parent.classList.toString().toLowerCase().includes('compare') ||
                        parent.style.textDecoration ||
                        parent.style.lineThrough
                      )) {
                        return NodeFilter.FILTER_REJECT;
                      }
                      parent = parent.parentNode;
                    }
                    return NodeFilter.FILTER_ACCEPT;
                  }
                }
              );

              let textNode;
              while (textNode = walker.nextNode()) {
                if (textNode.textContent.includes(numberToMultiply.toString())) {
                  textNode.textContent = textNode.textContent.replace(
                    new RegExp(`\\$?${numberToMultiply.toString().replace('.', '\\.')}`),
                    `$${multipliedNumber}`
                  );
                  break;
                }
              }

              subtitleElement.innerHTML = tempDiv.innerHTML;
            } else {
              const hasExistingDollar = subtitleText.includes('$');
              const newPrice = hasExistingDollar ?
                subtitleText.replace(/\$?\d+(\.\d+)?/, `$${multipliedNumber}`) :
                subtitleText.replace(/\d+(\.\d+)?/, `$${multipliedNumber}`);
              subtitleElement.textContent = newPrice;
            }
          } else {
            console.log('   No valid price found to multiply');
          }
        } else {
          console.log(`  Title does not contain "(${TARGET_KEYWORD})"`);
        }
      } else {
        console.log(`\n  Tile ${index + 2} (Div ${divIndex + 1}): Missing title or subtitle element`);
      }
    });
  });


  function getProcessedProductData() {
    const expandedDivs = document.querySelectorAll('div[data-is-expanded="true"]');
    const allResults = [];

    expandedDivs.forEach((expandedDiv, divIndex) => {
      const allProductTiles = expandedDiv.querySelectorAll(':scope > .tolstoy-product-tile');
      const productTilesFromSecond = Array.from(allProductTiles).slice(1);

      productTilesFromSecond.forEach((tile, index) => {
        const titleElement = tile.querySelector('.tolstoy-product-tile-title');
        const subtitleElement = tile.querySelector('.tolstoy-product-tile-subtitle');

        if (titleElement && subtitleElement) {
          const titleText = titleElement.textContent.trim();
          const subtitleText = subtitleElement.textContent.trim();

          const result = {
            divIndex: divIndex + 1,
            tileIndex: index + 2,
            title: titleText,
            subtitle: subtitleText,
            hasTargetKeyword: titleText.includes(`(${TARGET_KEYWORD})`),
            multipliedValue: null
          };

          if (result.hasTargetKeyword) {
            const compareSpans = subtitleElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');

            let numberToMultiply = null;
            let isComparePrice = false;

            if (compareSpans.length > 0) {
              isComparePrice = true;
              const tempElement = subtitleElement.cloneNode(true);
              const tempCompareSpans = tempElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
              tempCompareSpans.forEach(span => span.remove());
              const mainPriceText = tempElement.textContent.trim();
              const mainPriceMatch = mainPriceText.match(/\d+(\.\d+)?/);
              if (mainPriceMatch) {
                numberToMultiply = parseFloat(mainPriceMatch[0]);
              }
            } else {
              const numberMatch = subtitleText.match(/\d+(\.\d+)?/);
              if (numberMatch) {
                numberToMultiply = parseFloat(numberMatch[0]);
              }
            }

            if (numberToMultiply) {
              result.multipliedValue = numberToMultiply * 2;

              if (isComparePrice) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = subtitleElement.innerHTML;

                const walker = document.createTreeWalker(
                  tempDiv,
                  NodeFilter.SHOW_TEXT,
                  {
                    acceptNode: function (node) {
                      let parent = node.parentNode;
                      while (parent && parent !== tempDiv) {
                        if (parent.classList && (
                          parent.classList.toString().toLowerCase().includes('compare') ||
                          parent.style.textDecoration ||
                          parent.style.lineThrough
                        )) {
                          return NodeFilter.FILTER_REJECT;
                        }
                        parent = parent.parentNode;
                      }
                      return NodeFilter.FILTER_ACCEPT;
                    }
                  }
                );

                let textNode;
                while (textNode = walker.nextNode()) {
                  if (textNode.textContent.includes(numberToMultiply.toString())) {
                    textNode.textContent = textNode.textContent.replace(
                      new RegExp(`\\$?${numberToMultiply.toString().replace('.', '\\.')}`),
                      `$${result.multipliedValue}`
                    );
                    break;
                  }
                }

                subtitleElement.innerHTML = tempDiv.innerHTML;
              } else {
                const hasExistingDollar = subtitleText.includes('$');
                const newPrice = hasExistingDollar ?
                  subtitleText.replace(/\$?\d+(\.\d+)?/, `$${result.multipliedValue}`) :
                  subtitleText.replace(/\d+(\.\d+)?/, `$${result.multipliedValue}`);
                subtitleElement.textContent = newPrice;
              }
            }
          }

          allResults.push(result);
        }
      });
    });

    return allResults;
  }


  function updateSubtitlePreservingFormat() {
    const expandedDivs = document.querySelectorAll('div[data-is-expanded="true"]');

    expandedDivs.forEach((expandedDiv, divIndex) => {
      const allProductTiles = expandedDiv.querySelectorAll(':scope > .tolstoy-product-tile');
      const productTilesFromSecond = Array.from(allProductTiles).slice(1);

      productTilesFromSecond.forEach((tile, index) => {
        const titleElement = tile.querySelector('.tolstoy-product-tile-title');
        const subtitleElement = tile.querySelector('.tolstoy-product-tile-subtitle');

        if (titleElement && subtitleElement) {
          const titleText = titleElement.textContent.trim();

          if (titleText.includes(`(${TARGET_KEYWORD})`)) {
            const compareSpans = subtitleElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');

            let numberToMultiply = null;
            let isComparePrice = false;

            if (compareSpans.length > 0) {
              isComparePrice = true;
              const tempElement = subtitleElement.cloneNode(true);
              const tempCompareSpans = tempElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
              tempCompareSpans.forEach(span => span.remove());
              const mainPriceText = tempElement.textContent.trim();
              const mainPriceMatch = mainPriceText.match(/\d+(\.\d+)?/);
              if (mainPriceMatch) {
                numberToMultiply = parseFloat(mainPriceMatch[0]);
              }
            } else {
              const subtitleText = subtitleElement.textContent.trim();
              const numberMatch = subtitleText.match(/\d+(\.\d+)?/);
              if (numberMatch) {
                numberToMultiply = parseFloat(numberMatch[0]);
              }
            }

            if (numberToMultiply) {
              const multipliedNumber = numberToMultiply * 2;

              if (isComparePrice) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = subtitleElement.innerHTML;

                const walker = document.createTreeWalker(
                  tempDiv,
                  NodeFilter.SHOW_TEXT,
                  {
                    acceptNode: function (node) {
                      let parent = node.parentNode;
                      while (parent && parent !== tempDiv) {
                        if (parent.classList && (
                          parent.classList.toString().toLowerCase().includes('compare') ||
                          parent.style.textDecoration ||
                          parent.style.lineThrough
                        )) {
                          return NodeFilter.FILTER_REJECT;
                        }
                        parent = parent.parentNode;
                      }
                      return NodeFilter.FILTER_ACCEPT;
                    }
                  }
                );

                let textNode;
                while (textNode = walker.nextNode()) {
                  if (textNode.textContent.includes(numberToMultiply.toString())) {
                    textNode.textContent = textNode.textContent.replace(
                      new RegExp(`\\$?${numberToMultiply.toString().replace('.', '\\.')}`),
                      `$${multipliedNumber}`
                    );
                    break;
                  }
                }

                subtitleElement.innerHTML = tempDiv.innerHTML;
                console.log(`Updated subtitle (preserved compare price): main price $${numberToMultiply} → $${multipliedNumber}`);
              } else {
                const subtitleText = subtitleElement.textContent.trim();
                const hasExistingDollar = subtitleText.includes('$');
                const newPrice = hasExistingDollar ?
                  subtitleText.replace(/\$?\d+(\.\d+)?/, `$${multipliedNumber}`) :
                  subtitleText.replace(/\d+(\.\d+)?/, `$${multipliedNumber}`);
                subtitleElement.textContent = newPrice;
                console.log(`Updated subtitle from "${subtitleText}" to "${newPrice}"`);
              }
            }
          }
        }
      });
    });
  }

  // updateSubtitlePreservingFormat();


  function setupMutationObserver() {
    function processExpandedDivs() {
      const expandedDivs = document.querySelectorAll('div[data-is-expanded="true"]');
      if (expandedDivs.length === 0) return;

      console.log(`MutationObserver: Found ${expandedDivs.length} expanded divs`);

      expandedDivs.forEach((expandedDiv, divIndex) => {
        const allProductTiles = expandedDiv.querySelectorAll(':scope > .tolstoy-product-tile');
        const productTilesFromSecond = Array.from(allProductTiles).slice(1);

        productTilesFromSecond.forEach((tile, index) => {
          const titleElement = tile.querySelector('.tolstoy-product-tile-title');
          const subtitleElement = tile.querySelector('.tolstoy-product-tile-subtitle');

          if (titleElement && subtitleElement) {
            const titleText = titleElement.textContent.trim();
            const subtitleText = subtitleElement.textContent.trim();

            if (subtitleElement.dataset.processed === 'true') return;

            if (titleText.includes(`(${TARGET_KEYWORD})`)) {
              const compareSpans = subtitleElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');

              let numberToMultiply = null;
              let isComparePrice = false;

              if (compareSpans.length > 0) {
                isComparePrice = true;
                const tempElement = subtitleElement.cloneNode(true);
                const tempCompareSpans = tempElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
                tempCompareSpans.forEach(span => span.remove());
                const mainPriceText = tempElement.textContent.trim();
                const mainPriceMatch = mainPriceText.match(/\d+(\.\d+)?/);
                if (mainPriceMatch) {
                  numberToMultiply = parseFloat(mainPriceMatch[0]);
                }
              } else {
                const numberMatch = subtitleText.match(/\d+(\.\d+)?/);
                if (numberMatch) {
                  numberToMultiply = parseFloat(numberMatch[0]);
                }
              }

              if (numberToMultiply) {
                const multipliedNumber = numberToMultiply * 2;

                console.log(`MutationObserver: Processing Tile ${index + 2} (Div ${divIndex + 1})`);
                console.log(`  ${isComparePrice ? 'Compare price scenario' : 'Single price scenario'}: $${numberToMultiply} → $${multipliedNumber}`);

                if (isComparePrice) {
                  const tempDiv = document.createElement('div');
                  tempDiv.innerHTML = subtitleElement.innerHTML;

                  const walker = document.createTreeWalker(
                    tempDiv,
                    NodeFilter.SHOW_TEXT,
                    {
                      acceptNode: function (node) {
                        let parent = node.parentNode;
                        while (parent && parent !== tempDiv) {
                          if (parent.classList && (
                            parent.classList.toString().toLowerCase().includes('compare') ||
                            parent.style.textDecoration ||
                            parent.style.lineThrough
                          )) {
                            return NodeFilter.FILTER_REJECT;
                          }
                          parent = parent.parentNode;
                        }
                        return NodeFilter.FILTER_ACCEPT;
                      }
                    }
                  );

                  let textNode;
                  while (textNode = walker.nextNode()) {
                    if (textNode.textContent.includes(numberToMultiply.toString())) {
                      textNode.textContent = textNode.textContent.replace(
                        new RegExp(`\\$?${numberToMultiply.toString().replace('.', '\\.')}`),
                        `$${multipliedNumber}`
                      );
                      break;
                    }
                  }

                  subtitleElement.innerHTML = tempDiv.innerHTML;
                } else {
                  const hasExistingDollar = subtitleText.includes('$');
                  const newPrice = hasExistingDollar ?
                    subtitleText.replace(/\$?\d+(\.\d+)?/, `$${multipliedNumber}`) :
                    subtitleText.replace(/\d+(\.\d+)?/, `$${multipliedNumber}`);
                  subtitleElement.textContent = newPrice;
                }

                subtitleElement.dataset.processed = 'true';
              }
            }
          }
        });
      });
    }

    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.matches && (
                node.matches('div[data-is-expanded="true"]') ||
                node.matches('.tolstoy-product-tile') ||
                node.querySelector('div[data-is-expanded="true"]') ||
                node.querySelector('.tolstoy-product-tile')
              )) {
                shouldProcess = true;
              }
            }
          });
        }

        if (mutation.type === 'attributes' &&
          mutation.attributeName === 'data-is-expanded' &&
          mutation.target.getAttribute('data-is-expanded') === 'true') {
          shouldProcess = true;
        }
      });

      if (shouldProcess) {
        setTimeout(processExpandedDivs, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-is-expanded']
    });

    processExpandedDivs();

    return observer;
  }

  const productTileObserver = setupMutationObserver();

  console.log("✅ Product Tile Processor initialized and ready!");
});